import { useEffect, useState } from 'react';

const useCountdownV2 = (to: Date): { days: string; hours: string; minutes: string; seconds: string } => {
	const [remainingTime, setRemainingTime] = useState(0);

	useEffect(() => {
		const intervalId = setInterval(() => {
			const now = new Date().getTime();
			const distance = new Date(to as Date).getTime() - now;
			setRemainingTime(distance);
		}, 1000);

		return () => clearInterval(intervalId);
	}, [to]);

	return getTimeValues(remainingTime);
};

const getTimeValues = (remainingTime: number) => {
	const seconds = Math.floor((remainingTime / 1000) % 60);
	const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
	const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
	const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));

	return {
		days: days < 0 ? '00' : days.toString().padStart(2, '0'),
		hours: hours < 0 ? '00' : hours.toString().padStart(2, '0'),
		minutes: minutes < 0 ? '00' : minutes.toString().padStart(2, '0'),
		seconds: seconds < 0 ? '00' : seconds.toString().padStart(2, '0'),
	};
};

export { useCountdownV2 };
